import React from 'react';
import { SupportContainer, SupportMessage } from './styles';

const Support: React.FC = () => {
  return (
    <SupportContainer>
      <SupportMessage>
        For assistance, please email us at{' '}
        <a href="mailto:hello@prezziepal.com">hello@prezziepal.com</a>.
      </SupportMessage>
    </SupportContainer>
  );
};

export default Support;
